import LlReaderPdfBtn from "./ll-reader-pdf-btn.marko";

<if=!input.data.adventure>
  <div class="container">
    <div class="empty">
      <div class="empty__icon">🗺️</div>
      <p class="empty__title">${input.data.notFoundTitle}</p>
      <a href=input.data.basePath class="btn btn--outline" style="margin-top:var(--space-md)">← ${input.data.backLabel}</a>
    </div>
  </div>
</if>
<else>
  <div class="container">
    <div class="reader-wrap reader-wrap--full" style="padding-bottom:0">
      <main class="reader-main">
        <a href=input.data.basePath style="display:inline-flex;align-items:center;gap:4px;font-size:0.88rem;color:var(--color-text-muted);margin-bottom:var(--space-lg)">
          ← ${input.data.allLabel}
        </a>

        <if=input.data.adventure.learnerTitle>
          <p class="title-aid title-aid--detail">${input.data.adventure.learnerTitle}</p>
        </if>
        <div class="reader-title-row">
          <h1 class="reader-title">${input.data.adventure.targetTitle || input.data.adventure.title}</h1>
          <if=input.data.pdfUrl>
            <LlReaderPdfBtn
              pdfUrl=input.data.pdfUrl
              title=input.data.downloadPdfLabel
              ariaLabel=input.data.downloadPdfAriaLabel
              label=input.data.pdfAbbrevLabel
            />
          </if>
        </div>
        <div class="reader-desc-row">
          <div class="reader-desc-row__badges">
            <span class=`badge badge--${(input.data.adventure.level || '').toLowerCase()}`>${input.data.adventure.level}</span>
          </div>
          <p class="reader-desc">${input.data.adventure.description || input.data.adventure.translatedDescription || input.data.adventure.teaser || input.data.adventure.translatedTeaser || ""}</p>
        </div>

        <if=input.data.firstSceneHref>
          <a href=input.data.firstSceneHref class="btn btn--accent btn--lg">
            ${input.data.startLabel}
          </a>
        </if>
        <else>
          <a href=input.data.basePath class="btn btn--outline">← ${input.data.backLabel}</a>
        </else>
      </main>
    </div>

    <div style="padding:var(--space-xl) 0 var(--space-2xl)">
      <h2 style="font-size:1.1rem; font-weight:700; margin-bottom:var(--space-lg)">${input.data.scenesOverviewLabel}</h2>
      <div class="card-grid card-grid--4" id="ll-adventure-scene-grid" data-words-label=input.data.wordsLabel data-vocabs-stripe-label=input.data.vocabsStripeLabel data-stripe-beyond-prefix=input.data.stripeBeyondLevelPrefix>
        <for|scene, idx| of=(input.data.scenes || [])>
          <a
            href=(scene.href || "#")
            class="card adventure-scene-card"
            data-scene-card
            data-scene-id=(scene.contentId || "")
            data-scene-first=(idx === 0 ? "1" : "0")
            data-stats=(scene.stats ? JSON.stringify(scene.stats) : null)
            data-card-level=(input.data.adventure.level || '').toLowerCase()
          >
            <div class="card__image-wrap">
              <if=(idx === 0)>
                <span class="adventure-scene-card__start-badge" aria-hidden="true">${input.data.startHereSceneLabel}</span>
              </if>
              <if=scene.sceneCardImageSrc>
                <img
                  src=scene.sceneCardImageSrc
                  alt=(scene.targetTitle || scene.title || "")
                  class="card__image"
                  loading="lazy"
                  onError="this.style.display='none';var f=this.nextElementSibling;if(f&&f.classList&&f.classList.contains('card__image-placeholder'))f.removeAttribute('hidden')"
                >
                <div class="card__image-placeholder" hidden>🎬</div>
              </if>
              <else>
                <div class="card__image-placeholder">🎬</div>
              </else>
            </div>
            <div class="card__body">
              <div class="card__meta">
                <div class="ll-card-level-stripe-host" data-level-stripe tabindex="-1" aria-hidden="true"></div>
                <span class="badge badge--lang">${input.data.sceneLabel} ${idx + 1}</span>
                <span class="badge badge--lang adventure-scene-card__visited-badge">${input.data.visitedLabel}</span>
                <span class="badge badge--lang adventure-scene-card__locked-badge">${input.data.lockedLabel}</span>
              </div>
              <if=scene.learnerTitle>
                <p class="title-aid">${scene.learnerTitle}</p>
              </if>
              <h3 class="card__title">${scene.targetTitle || scene.title || scene.slug || scene.contentId}</h3>
              <p class="card__teaser">${scene.description || scene.teaser || ""}</p>
              <div class="ll-card-stripe ll-card-stripe--bottom" data-stripe-bottom aria-hidden="true"></div>
            </div>
          </a>
        </for>
      </div>
    </div>
  </div>

  <html-script id="adventure-overview-data" type="application/json">
    $!{JSON.stringify({ adventureId: input.data.adventure.contentId })}
  </html-script>
  <html-script src="/js/adventure-overview-client.js"></html-script>
  </else>
